import React from 'react';
import { Card, Divider } from 'antd';
import { Col, Row } from 'antd/es/grid';
import { Link } from 'react-router-dom';
import { SupportContent } from '../SupportContent';

function SupportDropdown() {
  return (
    <Card className="gx-card gx-mb-0 custom-user-dropdown gx-d-flex gx-flex-column" style={{ width: 300 }}>
      <Row>
        <SupportContent contentTheme='dark'/>
        <Col xs={24} className="gx-d-flex">
            <Divider />
        </Col>
        <Col xs={24} className="gx-d-flex gx-justify-content-center">
            <Link to="/appeal" title="Список обращений" className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap">
                Список обращений
            </Link>
        </Col>
      </Row>
    </Card>
  );
}

export default SupportDropdown;